module.exports = __webpack_public_path__ + "img/office-1988-9-building.46a1e9d7.jpg";